export type INTERFACE_TYPE = (typeof INTERFACE_TYPE)[keyof typeof INTERFACE_TYPE];
export const INTERFACE_TYPE = {
  classic: 'classic',
  new: 'modern',
} as const;

export type LANG = (typeof LANG)[keyof typeof LANG];
export const LANG = {
  en_US: 'en_US',
  ky_KG: 'ky_KG',
  ru_RU: 'ru_RU',
  tg_TJ: 'tg_TJ',
  uz_UZ: 'uz_UZ',
} as const;

export const I18N_AUTH_TEXT = {
  [LANG.en_US]: 'To continue taking the survey, you need to log in',
  [LANG.ky_KG]: 'Сурамжылоону улантуу үчүн, киришиңиз керек',
  [LANG.ru_RU]: 'Для продолжения прохождения опроса вам необходимо авторизоваться',
  [LANG.tg_TJ]: 'Барои идома додани пурсиш, шумо бояд ворид шавед',
  [LANG.uz_UZ]: "So'rovnomani davom ettirish uchun siz tizimga kirishingiz kerak",
} as const;

export const I18N_FINAL_OFFER = {
  [LANG.en_US]: 'Thank you!',
  [LANG.ky_KG]: 'Рахмат!',
  [LANG.ru_RU]: 'Спасибо!',
  [LANG.tg_TJ]: 'Ташаккур!',
  [LANG.uz_UZ]: 'Rahmat!',
} as const;

export const I18N_DISCLAIMER = {
  [LANG.en_US]: 'Do not use this form to transfer personal data',
  [LANG.ky_KG]: 'Жеке маалыматтарды берүү үчүн бул форманы колдонбоңуз',
  [LANG.ru_RU]: 'Не используйте эту форму для передачи персональных данных',
  [LANG.tg_TJ]: 'Ин шаклро барои интиқоли маълумоти шахсӣ истифода набаред',
  [LANG.uz_UZ]: "Shaxsiy ma'lumotlarni uzatish uchun ushbu shakldan foydalanmang",
} as const;

export const MATRIX_POLL_MULTIPLE = 'MATRIX_POLL_MULTIPLE';
export const MATRIX_POLL_RATING_DIGITS = 'MATRIX_POLL_RATING_DIGITS';
export const MATRIX_POLL_RATING_STARS = 'MATRIX_POLL_RATING_STARS';
export const MATRIX_POLL_SINGLE = 'MATRIX_POLL_SINGLE';

export const POLL_DEFAULT_THEME_ID = '213';
